module.exports = __webpack_public_path__ + "img/中国地图.1d998cec.png";